import React from "react";

import { Route } from "react-router-dom";

import { PrivacyPolicy } from "../../components/Privacypolicy";
import { SupplierAcceptOrDeclineInvitePage } from "../../components/SupplierInvite";
import { PUBLIC_ROUTES } from "../../constants";
import ApproveCompany from "../../pages/public/ApproveCompany";
import ConfirmEmailAddress from "../../pages/public/ConfirmEmailAddress";
import EstimateQuote from "../../pages/public/EstimateQuote";
import ForgotPassword from "../../pages/public/ForgotPassword";
import { ShipmentTrackingClientPage } from "../../pages/public/ShipmentTrackingClient";
import SignIn from "../../pages/public/SignIn";
import SignUp from "../../pages/public/SignUp";
import UpdatePassword from "../../pages/public/UpdatePassword";
import CustomerInvite from "../../pages/public/CustomerInvite";
import { AcceptedTaskInvite } from "../../pages/public/AgentInvite/AcceptTasktInvite";
import { RejectedTaskInvite } from "../../pages/public/AgentInvite/RejectTaskInvite";
import { AcceptShipeeziNetworkInvite } from "../../pages/public/AgentInvite/AcceptShipeeziNetworkInvite";
import { RejectShipeeziNetworkInvite } from "../../pages/public/AgentInvite/RejectShipeeziNetworkInvite";

export const PublicRoutes = () => {
  return (
    <>
      <Route path={PUBLIC_ROUTES.SIGN_IN} component={SignIn} />
      <Route path={PUBLIC_ROUTES.SIGN_UP} component={SignUp} />
      <Route path={PUBLIC_ROUTES.FORGOT} component={ForgotPassword} />
      <Route path={PUBLIC_ROUTES.UPDATE_PASSWORD} component={UpdatePassword} />
      <Route path={PUBLIC_ROUTES.CONFIRM_EMAIL_ADDRESS} component={ConfirmEmailAddress} />
      <Route path={PUBLIC_ROUTES.ACCEPT_TASK_INVITE} exact component={AcceptedTaskInvite} />
      <Route path={PUBLIC_ROUTES.REJECT_TASK_INVITE} exact component={RejectedTaskInvite} />
      <Route
        path={PUBLIC_ROUTES.ACCEPT_SHIPEEZI_NETWORK_INVITE}
        exact
        component={AcceptShipeeziNetworkInvite}
      />
      <Route
        path={PUBLIC_ROUTES.REJECT_SHIPEEZI_NETWORK_INVITE}
        exact
        component={RejectShipeeziNetworkInvite}
      />
      <Route path={PUBLIC_ROUTES.APPROVE_COMPANY_TEMPORARY} exact component={ApproveCompany} />
      <Route
        path={PUBLIC_ROUTES.SUPPLIER_ACCEPT_INVITE}
        exact
        component={SupplierAcceptOrDeclineInvitePage}
      />
      <Route
        path={`${PUBLIC_ROUTES.SHIPMENT_TRACKING_CLIENT}`}
        exact
        component={ShipmentTrackingClientPage}
      />
      <Route path={PUBLIC_ROUTES.PRIVACY_POLICY} component={PrivacyPolicy} />
      <Route path={PUBLIC_ROUTES.ESTIMATE_QUOTE} exact component={EstimateQuote} />
      <Route path={PUBLIC_ROUTES.CUSTOMER_ACCEPT_INVITE} exact component={CustomerInvite} />
    </>
  );
};
